import { faArrowRight, faChevronRight } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Link } from 'react-router-dom';
import Illustration from '../base/Illustration';

interface Props {
  link: string;
  illustration: string;
  title: any;
  description: string;
  children?: any;
}

const Tile = ({ title, link, description, illustration, children }: Props) => {
  return (
    <Link
      to={link}
      className="shadow relative rounded-xl bg-white flex-row flex p-[30px] cursor-pointer group hover:ring w-full min-h-[250px] border-[#efefef] hover:ring-gray-300"
    >
      <Illustration
        id={illustration}
        className="flex-none absolute bottom-[30px] left-[30px]"
        height={90}
      />

      <div>
        <p className="text-xl font-semibold">{title}</p>
        <div className="mt-2 text-gray-500 text-xs">{description}</div>
      </div>

      <div className="group-hover:bg-[var(--theme-primary)] group-hover:text-[var(--theme-primary-text)] absolute bottom-[20px] right-[20px] bg-gray-100 flex justify-center items-center rounded-full w-[40px] h-[40px]">
        <FontAwesomeIcon icon={faChevronRight} size="lg" />
      </div>

      {children}
    </Link>
  );
};

export default Tile;
